import random from 'lodash/random';
import isEqual from 'lodash/isEqual';
import replace from 'lodash/replace';
import findKey from 'lodash/findKey';

export const AnalyticsShow = {
    ShareOK:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwa&pr=%random%&ptrc=b',
    ShareVK:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwb&pr=%random%&ptrc=b',
    ShareTG:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwc&pr=%random%&ptrc=b',
    ResultShareOK:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwd&pr=%random%&ptrc=b',
    ResultShareVK:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwe&pr=%random%&ptrc=b',
    ResultShareTG:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwf&pr=%random%&ptrc=b',
    StartGame:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwvz&pr=%random%&ptrc=b',
    FinalScreen:
        'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwvq&pr=%random%&ptrc=b',
};

export const AnalyticsClick = {
    PikabuLogo: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwvf&pr=%random%',
    PartnerLogo: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwvg&pr=%random%',
};

export const prepareUrl = (url: string): string => {
    return replace(url, '%random%', random(100, 9999999).toString());
};

export const analytics = (url: string): string => {
    if (typeof window !== 'undefined') {
        if (findKey(AnalyticsClick, (value) => isEqual(url, value))) {
            return prepareUrl(url);
        }
        const img = document.createElement('img');
        img.src = prepareUrl(url);
        img.setAttribute('class', 'ad-pixel');
        img.setAttribute('style', 'position: absolute; width: 1px; height: 1px; top: 0;');
        document.body.appendChild(img);
        return '';
    }
};
